import { render, staticRenderFns } from "./DesignerDetail.vue?vue&type=template&id=7272f05f&scoped=true"
import script from "./DesignerDetail.vue?vue&type=script&lang=js"
export * from "./DesignerDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignerDetail.vue?vue&type=style&index=0&id=7272f05f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272f05f",
  null
  
)

export default component.exports